import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1, ModalFullscreen } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ModalWithContacts.css';

export interface IModalWithContactsProps {
  children?: React.ReactNode;
  builderName?: string;
  callbackButton?: React.ReactNode;
  contactsButton?: React.ReactNode;
  name: string;
  onClose(): void;
  open: boolean;
  price: string;
  pricePerMeter?: string;
}

export function ModalWithContacts({
  children,
  builderName,
  callbackButton,
  contactsButton,
  name,
  onClose,
  open,
  price,
  pricePerMeter,
}: IModalWithContactsProps) {
  return (
    <ModalFullscreen open={open} onClose={onClose} theme="white">
      <div className={styles['container']}>
        <div className={styles['view']}>{children}</div>

        <div className={styles['info']}>
          <button className={styles['close-button']} type="button" onClick={onClose} data-testid="CloseModalButton">
            <IconActionClose16 color="gray60_100" />
          </button>

          <div className={styles['info-section']}>
            <div className={styles['info-block']}>
              <ArticleParagraph1 as="h3" fontWeight="bold">
                {name}
              </ArticleParagraph1>
            </div>
            <div className={styles['info-block']}>
              <ArticleHeading1 as="p" whiteSpace="pre-line">
                {price}
              </ArticleHeading1>
            </div>
            {pricePerMeter && (
              <div className={styles['info-block']}>
                <ArticleParagraph1>{pricePerMeter}</ArticleParagraph1>
              </div>
            )}
          </div>

          <ArticleParagraph1>
            Узнайте больше подробностей о&nbsp;квартире и&nbsp;жилом комплексе
            {builderName && ` у\xA0застройщика ${builderName}`}
          </ArticleParagraph1>

          <div className={styles['contact-button']} data-testid="InfoModalContactsButtonWrapper">
            {contactsButton}
          </div>
          <div className={styles['contact-button']} data-testid="InfoModalCallbackButtonWrapper">
            {callbackButton}
          </div>
        </div>
      </div>
    </ModalFullscreen>
  );
}
